module.exports = __webpack_public_path__ + "media/dog-profile-avatars/single-dalmatian-2d12cccb.svg";